(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-before-after-results"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('custom-before-after-compare')) return;

    var clampToPercentageRange = function (value) {
      return Math.min(100, Math.max(0, value));
    };
    var DRAG_ENGAGE_THRESHOLD_PIXELS = 6; // px before a touch is treated as a horizontal drag
    var KEYBOARD_STEP_PERCENT = 2;
    var KEYBOARD_STEP_LARGE_PERCENT = 10;

    class CustomBeforeAfterCompare extends HTMLElement {
      constructor() {
        super();
        this.currentSliderPosition = 50;
        this.activeDrag = null;
        this.eventListenerController = null;

        this.handlePointerDown = this.handlePointerDown.bind(this);
        this.handlePointerMove = this.handlePointerMove.bind(this);
        this.handlePointerEnd = this.handlePointerEnd.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
      }

      connectedCallback() {
        var startingPosition = parseFloat(this.getAttribute('data-start'));
        this.currentSliderPosition = isNaN(startingPosition) ? 50 : clampToPercentageRange(startingPosition);

        // Listeners live on the host so they work even if children parse later,
        // and a single AbortController removes them all on disconnect.
        this.eventListenerController = new AbortController();
        var listenerOptions = { signal: this.eventListenerController.signal };
        this.addEventListener('pointerdown', this.handlePointerDown, listenerOptions);
        this.addEventListener('pointermove', this.handlePointerMove, listenerOptions);
        this.addEventListener('pointerup', this.handlePointerEnd, listenerOptions);
        this.addEventListener('pointercancel', this.handlePointerEnd, listenerOptions);
        this.addEventListener('lostpointercapture', this.handlePointerEnd, listenerOptions);
        this.addEventListener('keydown', this.handleKeyDown, listenerOptions);
      }

      disconnectedCallback() {
        if (this.eventListenerController) this.eventListenerController.abort();
        this.eventListenerController = null;
        this.activeDrag = null;
        this.removeAttribute('data-dragging');
      }

      queryComparisonElement(selector) {
        return this.querySelector(selector);
      }

      setSliderPosition(value) {
        var clampedPosition = clampToPercentageRange(value);
        this.currentSliderPosition = clampedPosition;
        this.style.setProperty('--custom-before-after-results-slider-position', clampedPosition + '%');

        var sliderHandle = this.queryComparisonElement('[data-comparison-handle]');
        if (sliderHandle) {
          var roundedPosition = Math.round(clampedPosition);
          sliderHandle.setAttribute('aria-valuenow', String(roundedPosition));
          sliderHandle.setAttribute(
            'aria-valuetext',
            roundedPosition +
              '% ' +
              (this.getAttribute('data-before-label') || 'Before') +
              ', ' +
              (100 - roundedPosition) +
              '% ' +
              (this.getAttribute('data-after-label') || 'After')
          );
        }
      }

      moveSliderToClientX(clientX) {
        var comparisonStage = this.queryComparisonElement('[data-comparison-stage]');
        var dragState = this.activeDrag;
        if (!comparisonStage || !dragState) return;
        var stageRect = comparisonStage.getBoundingClientRect();
        if (!stageRect.width) return;
        this.setSliderPosition(((clientX - dragState.offset - stageRect.left) / stageRect.width) * 100);
      }

      beginDrag(pointerEvent) {
        var dragState = this.activeDrag;
        dragState.engaged = true;
        try {
          this.setPointerCapture(pointerEvent.pointerId);
        } catch (_) {
          /* pointer already gone */
        }
        if (pointerEvent.pointerType !== 'touch' && pointerEvent.cancelable) pointerEvent.preventDefault(); // no text/image selection
        var sliderHandle = this.queryComparisonElement('[data-comparison-handle]');
        if (sliderHandle) sliderHandle.focus({ preventScroll: true });
        this.moveSliderToClientX(pointerEvent.clientX);
      }

      handlePointerDown(pointerEvent) {
        if (this.activeDrag) return;
        if (pointerEvent.pointerType === 'mouse' && pointerEvent.button !== 0) return;

        var comparisonStage = this.queryComparisonElement('[data-comparison-stage]');
        if (!comparisonStage || !comparisonStage.contains(pointerEvent.target)) return;
        var stageRect = comparisonStage.getBoundingClientRect();
        if (!stageRect.width) return;

        var sliderHandle = this.queryComparisonElement('[data-comparison-handle]');
        var pointerIsOnHandle = !!sliderHandle && sliderHandle.contains(pointerEvent.target);
        var isTouchPointer = pointerEvent.pointerType === 'touch';

        this.activeDrag = {
          id: pointerEvent.pointerId,
          x: pointerEvent.clientX,
          y: pointerEvent.clientY,
          // grabbing the handle off-centre must not make it jump
          offset: pointerIsOnHandle
            ? pointerEvent.clientX - (stageRect.left + (stageRect.width * this.currentSliderPosition) / 100)
            : 0,
          engaged: false,
        };

        // Mouse/pen: react immediately. Touch on the image: wait to see whether the
        // gesture is a horizontal drag (ours) or a vertical scroll (the browser's).
        if (!isTouchPointer || pointerIsOnHandle) this.beginDrag(pointerEvent);
      }

      handlePointerMove(pointerEvent) {
        var dragState = this.activeDrag;
        if (!dragState || pointerEvent.pointerId !== dragState.id) return;

        if (!dragState.engaged) {
          var deltaX = pointerEvent.clientX - dragState.x;
          var deltaY = pointerEvent.clientY - dragState.y;
          if (Math.abs(deltaX) > DRAG_ENGAGE_THRESHOLD_PIXELS && Math.abs(deltaX) > Math.abs(deltaY))
            this.beginDrag(pointerEvent);
          else return;
        }
        this.setAttribute('data-dragging', ''); // disables the easing while dragging
        this.moveSliderToClientX(pointerEvent.clientX);
      }

      handlePointerEnd(pointerEvent) {
        var dragState = this.activeDrag;
        if (!dragState || pointerEvent.pointerId !== dragState.id) return;
        // Touch pointers are implicitly captured by the element under the finger; when we
        // re-capture on the host the browser fires lostpointercapture on that inner element.
        // Only a lost capture on the host itself means our drag is really over.
        if (pointerEvent.type === 'lostpointercapture' && pointerEvent.target !== this) return;

        // A tap on the image (touch) that never turned into a drag = click-to-position.
        if (
          !dragState.engaged &&
          pointerEvent.type === 'pointerup' &&
          Math.abs(pointerEvent.clientX - dragState.x) <= DRAG_ENGAGE_THRESHOLD_PIXELS &&
          Math.abs(pointerEvent.clientY - dragState.y) <= DRAG_ENGAGE_THRESHOLD_PIXELS
        ) {
          this.moveSliderToClientX(pointerEvent.clientX);
        }

        this.activeDrag = null;
        this.removeAttribute('data-dragging');
        try {
          this.releasePointerCapture(pointerEvent.pointerId);
        } catch (_) {
          /* already released */
        }
      }

      handleKeyDown(keyboardEvent) {
        if (!keyboardEvent.target.closest || !keyboardEvent.target.closest('[data-comparison-handle]')) return;
        var nextPosition = this.currentSliderPosition;
        switch (keyboardEvent.key) {
          case 'ArrowLeft':
          case 'ArrowDown':
            nextPosition -= keyboardEvent.shiftKey ? KEYBOARD_STEP_LARGE_PERCENT : KEYBOARD_STEP_PERCENT;
            break;
          case 'ArrowRight':
          case 'ArrowUp':
            nextPosition += keyboardEvent.shiftKey ? KEYBOARD_STEP_LARGE_PERCENT : KEYBOARD_STEP_PERCENT;
            break;
          case 'PageDown':
            nextPosition -= KEYBOARD_STEP_LARGE_PERCENT;
            break;
          case 'PageUp':
            nextPosition += KEYBOARD_STEP_LARGE_PERCENT;
            break;
          case 'Home':
            nextPosition = 0;
            break;
          case 'End':
            nextPosition = 100;
            break;
          default:
            return;
        }
        keyboardEvent.preventDefault();
        this.setSliderPosition(nextPosition);
      }
    }

    customElements.define('custom-before-after-compare', CustomBeforeAfterCompare);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-botanical-ingredients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const activeTabClassName = 'custom-botanical-ingredients__tab--active';
    const activePanelClassName = 'custom-botanical-ingredients__panel--active';
    const activeProductTabClassName = 'custom-botanical-ingredients__product-tab--active';
    const activeProductGroupClassName = 'custom-botanical-ingredients__product-group--active';

    // Returns the index of the tab to move to for an arrow / Home / End key, or null.
    function getTargetTabIndex(event, currentIndex, tabCount, element) {
      const isRightToLeft = getComputedStyle(element).direction === 'rtl';
      switch (event.key) {
        case 'ArrowRight':
          return (currentIndex + (isRightToLeft ? -1 : 1) + tabCount) % tabCount;
        case 'ArrowLeft':
          return (currentIndex + (isRightToLeft ? 1 : -1) + tabCount) % tabCount;
        case 'Home':
          return 0;
        case 'End':
          return tabCount - 1;
        default:
          return null;
      }
    }

    // One botanical explorer (tabs + panels). A bundle product renders one per
    // product group; each instance only looks inside itself.
    class CustomBotanicalSection extends HTMLElement {
      constructor() {
        super();
        this.eventListenerController = null;

        this.handleTabClick = this.handleTabClick.bind(this);
        this.handleTabKeydown = this.handleTabKeydown.bind(this);
        this.handleEditorBlockSelect = this.handleEditorBlockSelect.bind(this);
      }

      connectedCallback() {
        this.initializeBotanicalTabs();
      }

      disconnectedCallback() {
        if (this.eventListenerController) {
          this.eventListenerController.abort();
          this.eventListenerController = null;
        }
      }

      // Listeners are delegated from this element, so they also work for tabs that
      // are added or replaced later, and one AbortController removes all of them.
      initializeBotanicalTabs() {
        if (this.eventListenerController) this.eventListenerController.abort();
        this.eventListenerController = new AbortController();
        const listenerOptions = { signal: this.eventListenerController.signal };

        this.addEventListener('click', this.handleTabClick, listenerOptions);
        this.addEventListener('keydown', this.handleTabKeydown, listenerOptions);
        this.addEventListener('shopify:block:select', this.handleEditorBlockSelect, listenerOptions);
      }

      getBotanicalTabs() {
        return Array.from(this.querySelectorAll('[data-botanical-tab]'));
      }

      getBotanicalPanels() {
        return Array.from(this.querySelectorAll('[data-botanical-panel]'));
      }

      handleTabClick(event) {
        const clickedTab = event.target.closest('[data-botanical-tab]');
        if (!clickedTab || !this.contains(clickedTab)) return;
        this.selectBotanical(clickedTab.dataset.botanicalBlockId);
      }

      handleTabKeydown(event) {
        const focusedTab = event.target.closest('[data-botanical-tab]');
        if (!focusedTab || !this.contains(focusedTab)) return;

        const botanicalTabs = this.getBotanicalTabs();
        const targetTabIndex = getTargetTabIndex(event, botanicalTabs.indexOf(focusedTab), botanicalTabs.length, this);
        if (targetTabIndex === null) return;

        event.preventDefault();
        this.selectBotanical(botanicalTabs[targetTabIndex].dataset.botanicalBlockId, { moveFocus: true });
      }

      // Theme Editor: selecting a botanical block in the sidebar shows that botanical.
      handleEditorBlockSelect(event) {
        const selectedBlockIdentifier = event.detail && event.detail.blockId;
        if (selectedBlockIdentifier) this.selectBotanical(selectedBlockIdentifier);
      }

      selectBotanical(blockIdentifier, options) {
        const selectedTab = this.getBotanicalTabs().find(function (botanicalTab) {
          return botanicalTab.dataset.botanicalBlockId === blockIdentifier;
        });
        if (!selectedTab) return;

        this.setActiveBotanicalTab(selectedTab);
        this.updateBotanicalContent(blockIdentifier);
        if (options && options.moveFocus) selectedTab.focus();
      }

      setActiveBotanicalTab(selectedTab) {
        this.getBotanicalTabs().forEach(function (botanicalTab) {
          const isSelected = botanicalTab === selectedTab;
          botanicalTab.classList.toggle(activeTabClassName, isSelected);
          botanicalTab.setAttribute('aria-selected', String(isSelected));
          botanicalTab.setAttribute('tabindex', isSelected ? '0' : '-1');
        });
      }

      updateBotanicalContent(blockIdentifier) {
        this.getBotanicalPanels().forEach(function (botanicalPanel) {
          const isSelected = botanicalPanel.dataset.botanicalBlockId === blockIdentifier;
          botanicalPanel.classList.toggle(activePanelClassName, isSelected);
        });
      }
    }

    // Bundle products only (Oil | Serum | Cream ...): switches which product
    // group (its own botanical explorer + full blend list) is visible. It only
    // touches [data-product-tab] / [data-product-group], never the botanical
    // tabs, so each group's <custom-botanical-section> keeps its own state.
    class CustomBotanicalProductTabs extends HTMLElement {
      constructor() {
        super();
        this.eventListenerController = null;

        this.handleProductTabClick = this.handleProductTabClick.bind(this);
        this.handleProductTabKeydown = this.handleProductTabKeydown.bind(this);
        this.handleEditorBlockSelect = this.handleEditorBlockSelect.bind(this);
      }

      connectedCallback() {
        this.initializeProductTabs();
      }

      disconnectedCallback() {
        if (this.eventListenerController) {
          this.eventListenerController.abort();
          this.eventListenerController = null;
        }
      }

      initializeProductTabs() {
        if (this.eventListenerController) this.eventListenerController.abort();
        this.eventListenerController = new AbortController();
        const listenerOptions = { signal: this.eventListenerController.signal };

        this.addEventListener('click', this.handleProductTabClick, listenerOptions);
        this.addEventListener('keydown', this.handleProductTabKeydown, listenerOptions);
        this.addEventListener('shopify:block:select', this.handleEditorBlockSelect, listenerOptions);
      }

      getProductTabs() {
        return Array.from(this.querySelectorAll('[data-product-tab]'));
      }

      getProductGroups() {
        return Array.from(this.querySelectorAll('[data-product-group]'));
      }

      handleProductTabClick(event) {
        const clickedTab = event.target.closest('[data-product-tab]');
        if (!clickedTab || !this.contains(clickedTab)) return;
        this.selectProductGroup(clickedTab.dataset.productTabGroupId);
      }

      handleProductTabKeydown(event) {
        const focusedTab = event.target.closest('[data-product-tab]');
        if (!focusedTab || !this.contains(focusedTab)) return;

        const productTabs = this.getProductTabs();
        const targetTabIndex = getTargetTabIndex(event, productTabs.indexOf(focusedTab), productTabs.length, this);
        if (targetTabIndex === null) return;

        event.preventDefault();
        this.selectProductGroup(productTabs[targetTabIndex].dataset.productTabGroupId, { moveFocus: true });
      }

      // Theme Editor: selecting a Product tab block shows its group. Selecting a
      // Botanical or Full blend ingredient block shows the group it is assigned
      // to, so the merchant always sees the block they are editing.
      handleEditorBlockSelect(event) {
        const selectedBlockIdentifier = event.detail && event.detail.blockId;
        if (!selectedBlockIdentifier) return;

        const matchesAProductTab = this.getProductTabs().some(function (productTab) {
          return productTab.dataset.productTabGroupId === selectedBlockIdentifier;
        });
        if (matchesAProductTab) {
          this.selectProductGroup(selectedBlockIdentifier);
          return;
        }

        const containingProductGroup = event.target instanceof Element ? event.target.closest('[data-product-group]') : null;
        if (containingProductGroup && this.contains(containingProductGroup)) {
          this.selectProductGroup(containingProductGroup.dataset.productTabGroupId);
        }
      }

      selectProductGroup(groupIdentifier, options) {
        const selectedTab = this.getProductTabs().find(function (productTab) {
          return productTab.dataset.productTabGroupId === groupIdentifier;
        });
        if (!selectedTab) return;

        this.setActiveProductTab(selectedTab);
        this.updateVisibleProductGroup(groupIdentifier);
        if (options && options.moveFocus) selectedTab.focus();
      }

      setActiveProductTab(selectedTab) {
        this.getProductTabs().forEach(function (productTab) {
          const isSelected = productTab === selectedTab;
          productTab.classList.toggle(activeProductTabClassName, isSelected);
          productTab.setAttribute('aria-selected', String(isSelected));
          productTab.setAttribute('tabindex', isSelected ? '0' : '-1');
        });
      }

      updateVisibleProductGroup(groupIdentifier) {
        this.getProductGroups().forEach(function (productGroup) {
          const isSelected = productGroup.dataset.productTabGroupId === groupIdentifier;
          productGroup.classList.toggle(activeProductGroupClassName, isSelected);
        });
      }
    }

    if (!customElements.get('custom-botanical-section')) {
      customElements.define('custom-botanical-section', CustomBotanicalSection);
    }
    if (!customElements.get('custom-botanical-product-tabs')) {
      customElements.define('custom-botanical-product-tabs', CustomBotanicalProductTabs);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
